import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, FormControl } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import messages from '../../../locale/messages';
import CustomPagination from '../../CustomPagination';
import PosConfirmModal from '../PosConfirmModal/PosConfirmModal';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import Link from '../../Link/Link';
import CurrencyConverter from '../../CurrencyConverter'
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirst';
import { openConfirmationModal } from '../../../actions/siteadmin/modalActions';
import ExportImage from '../../../../public/Icons/export.png';
import ExportImageDark from '../../../../public/Icons/exportDark.png';
import debounce from '../../../helpers/debounce';
import { connect } from 'react-redux';

import Loader from '../../../components/Common/Loader';

import bt from '../../../components/commonStyle.css';
import s from './BookingList.css';

export class CompletedBookingList extends Component {
    static propTypes = {
        completedTrips: PropTypes.object,
    }
    constructor(props) {
        super(props)
        this.scrollableDivRef = React.createRef();
        this.state = {
            currentPage: 1,
            isPosSelected: false
        }
        this.paginationData = this.paginationData.bind(this);
        this.handleKeywordSearch = debounce(this.handleKeywordSearch.bind(this), 250);
    }
    handleKeywordSearch(searchList) {
        const { completedTrips: { refetch } } = this.props
        let variables = {
            currentPage: 1,
            searchList
        }
        this.setState(variables)
        refetch(variables)
    }
    paginationData(currentPage) {
        const { completedTrips: { refetch } } = this.props;
        let variables = { currentPage };
        this.setState({ currentPage });
        if (this.scrollableDivRef.current) {
            this.scrollableDivRef.current.scrollTop = 0;
        }
        refetch(variables);
    }

    handlePaymentFilter = (value) => {
        const { completedTrips: { refetch } } = this.props
        let variables = {
            currentPage: 1,
            paymentType: value,
            posStatus: null
        }
        this.setState(variables)
        refetch(variables)
        this.setState({ isPosSelected: Number(value), filter: value })
    }

    handlePOSFilter = (value) => {
        const { completedTrips: { refetch } } = this.props
        let variables = {
            currentPage: 1,
            posStatus: value
        }
        this.setState(variables)
        refetch(variables)
        this.setState({ POSStatus: Number(value) })
    }

    render() {
        const { completedTrips, completedTrips: { getCompletedBookings }, loading, selectedTheme, openConfirmationModal } = this.props;
        const { currentPage, searchList, isPosSelected, filter, POSStatus } = this.state;
        const { formatMessage } = this.props.intl;
        let status = ['completed'];
        return (
            <div className={cx(s.widthInner, 'bgBlackTwo')}>
                <div className={bt.tableTopGrpContainer}>
                    <PosConfirmModal currentPage={currentPage} searchList={searchList} completedTrips={completedTrips}
                    />
                    <div className={s.searchInput}>
                        <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={bt.formControlInput} />
                    </div>
                    <div className={s.completedBookingFiltersFex}>
                        <select onChange={(e) => this.handlePaymentFilter(e.target.value)} className={bt.formControlSelect}>
                            <option value={''} >{formatMessage(messages.all)}</option>
                            <option value={'1'} >{formatMessage(messages.cash)}</option>
                            <option value={'2'} >{formatMessage(messages.card)}</option>
                            <option value={'3'} >{formatMessage(messages.wallet)}</option>
                            <option value={'4'} >{formatMessage(messages.googlePay)}</option>
                            <option value={'5'} >{formatMessage(messages.paystack)}</option>
                            <option value={'6'} >{formatMessage(messages.posPayment)}</option>
                        </select>
                        {isPosSelected === 6 &&
                            <select onChange={(e) => this.handlePOSFilter(e.target.value)} className={bt.formControlSelect}>
                                <option value={''} >{formatMessage(messages.all)}</option>
                                <option value={'1'}>{formatMessage(messages.verified)}</option>
                                <option value={'0'}>{formatMessage(messages.notVerified)}</option>
                            </select>
                        }
                        <div className={cx(bt.tableTopWrapper, bt.flexWrap, 'flex-shrink-0')}>
                            {
                                completedTrips && completedTrips.getCompletedBookings && completedTrips.getCompletedBookings.bookingData && completedTrips.getCompletedBookings.bookingData.length > 0 && <a
                                    href={`/export-admin-data?type=bookings&status[0]=completed&keyword=${searchList ? searchList : ''}&filter=${filter ? (filter != 6 ? filter : filter + `&isPOSStatus=${POSStatus}`) : ''}`}
                                    className={s.textDecorationNone}>
                                    <span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
                                    <span>
                                        {
                                            (selectedTheme && selectedTheme === "light") ?
                                                <img src={ExportImage} className={cx(s.exportImg)} /> : <img src={ExportImageDark} className={cx(s.exportImg)} />
                                        }
                                    </span>
                                </a>
                            }
                        </div>
                    </div>



                </div>
                <div class="clearfix"></div>
                {
                    loading && <div>
                        <Loader type="circle" />
                    </div>
                }
                {
                    !loading &&
                    <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewResponsiveTable', 'topScrollbarTable', 'whiteDropdown')} ref={this.scrollableDivRef}>
                        <Table className={cx("table", 'topScrollbarTableContent')}>
                            <thead>
                                <tr>
                                    <th scope="col"><FormattedMessage {...messages.id} /></th>
                                    {/* <th scope="col"><FormattedMessage {...messages.pickUpLocation} /></th>
                                <th scope="col"><FormattedMessage {...messages.dropLocation} /></th> */}
                                    <th scope="col"><FormattedMessage {...messages.riderName} /></th>
                                    <th scope="col"><FormattedMessage {...messages.driverName} /></th>
                                    <th scope="col"><FormattedMessage {...messages.category} /></th>
                                    <th scope="col"><FormattedMessage {...messages.vehicleNumber} /></th>
                                    <th scope="col"><FormattedMessage {...messages.tripStatus} /></th>
                                    {/* <th scope="col"><FormattedMessage {...messages.totalRideDistance} /></th>
                                <th scope="col"><FormattedMessage {...messages.totalDuration} /></th> */}
                                    <th scope="col"><FormattedMessage {...messages.paymentMethod} /></th>
                                    <th scope="col"><FormattedMessage {...messages.status} /></th>
                                    <th scope="col"><FormattedMessage {...messages.totalFare} /></th>
                                    {/* <th scope="col"><FormattedMessage {...messages.tollFee} /></th> */}
                                    <th scope="col"><FormattedMessage {...messages.details} /></th>
                                    <th scope="col"><FormattedMessage {...messages.chatLabel} /></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    completedTrips && completedTrips.getCompletedBookings && completedTrips.getCompletedBookings.bookingData && completedTrips.getCompletedBookings.bookingData.length > 0 && completedTrips.getCompletedBookings.bookingData.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td data-label={formatMessage(messages.id)}>{item.id}</td>
                                                {/* <td data-label={formatMessage(messages.id)}>{item.pickUpLocation}</td>
                                            <td data-label={formatMessage(messages.id)}>{item.dropOffLocation}</td> */}
                                                <td data-label={formatMessage(messages.riderName)}>{item && item.riderDetails && capitalizeFirstLetter(item.riderDetails.firstName)}</td>
                                                <td data-label={formatMessage(messages.driverName)}>{item && item.driverDetails && capitalizeFirstLetter(item.driverDetails.firstName)}</td>
                                                <td data-label={formatMessage(messages.category)}>{item && item.categoryDetails && item.categoryDetails.categoryName}</td>
                                                <td data-label={formatMessage(messages.vehicleNumber)}>{item && item.vehicleNumber && item.vehicleNumber.toUpperCase()}</td>
                                                <td data-label={formatMessage(messages.tripStatus)}>{item.tripStatus && messages[item.tripStatus] ? formatMessage(messages[item.tripStatus]) : item.tripStatus}</td>
                                                {/* <td data-label={formatMessage(messages.id)}>{item.totalRideDistance}</td>
                                            <td data-label={formatMessage(messages.id)}>{item.totalDuration}</td> */}
                                                <td data-label={formatMessage(messages.paymentMethod)}>{item && item.paymentType && item.paymentType && item.paymentType === 1 ? formatMessage(messages.cash) : (item.paymentType === 2 ? formatMessage(messages.card) : (item.paymentType === 5 ? formatMessage(messages.paystack) :
                                                    (item.paymentType === 3 ? formatMessage(messages.wallet) : (item.paymentType === 4 ? formatMessage(messages.googlePay) : formatMessage(messages.posPayment)))))}</td>
                                                <td data-label={formatMessage(messages.status)}>{item && item.paymentType && item.paymentType !== 6 ? "-" :
                                                    item.isPayoutVerified ? formatMessage(messages.verified) : <select name="isPayoutVerified" className={bt.selectInput} value={item.isPayoutVerified} onChange={() => openConfirmationModal(item.id)}>
                                                        <option value={false}>{formatMessage(messages.notVerified)}</option>
                                                        <option value={true}>{formatMessage(messages.verified)}</option>
                                                    </select>
                                                }
                                                </td>
                                                <td data-label={formatMessage(messages.totalFare)}><CurrencyConverter from={item.currency} amount={item.totalFare} /></td>
                                                {/* <td data-label={formatMessage(messages.tollFee)}><CurrencyConverter from={item.currency} amount={item.tollFee} /></td> */}
                                                <td data-label={formatMessage(messages.details)}><Link to={'/siteadmin/completed-bookings/view/' + item.id}><FormattedMessage {...messages.view} /></Link></td>
                                                <td data-label={formatMessage(messages.chatLabel)}>
                                                    {item.messageData && item.messageData.threadItemsCount > 0 && <Link to={'/siteadmin/completed-bookings/chat-message/' + item.id}><FormattedMessage {...messages.view} /></Link>}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                {
                                    completedTrips && completedTrips.getCompletedBookings && completedTrips.getCompletedBookings.bookingData && completedTrips.getCompletedBookings.bookingData.length == 0 && (
                                        <tr>
                                            <td colspan="12" className={s.noRecords}><FormattedMessage {...messages.noResult} /></td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                    </div>
                }
                {
                    completedTrips && completedTrips.getCompletedBookings && completedTrips.getCompletedBookings.bookingData && completedTrips.getCompletedBookings.bookingData.length > 0
                    && <div className={cx(bt.space5, bt.spaceTop5)}>
                        <CustomPagination
                            total={completedTrips.getCompletedBookings.count}
                            currentPage={currentPage}
                            defaultCurrent={1}
                            defaultPageSize={10}
                            change={this.paginationData}
                            paginationLabel={formatMessage(messages.manageCompletedTrips)}
                        />
                    </div>
                }
            </div >
        )
    }
}
const mapState = (state) => ({
    loading: state.intl.loading,
    selectedTheme: state.currency.theme
});

const mapDispatch = {
    openConfirmationModal
}
export default compose(injectIntl,
    withStyles(s, bt),
    connect(mapState, mapDispatch),
)(CompletedBookingList);

